module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.5438/img/app-marketplace-network-2x.png"